export default __webpack_public_path__ + "static/Rhodium11_cart-6bca6243c15dc6c9e32680765661585d.mp4";